/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/TaskInsertNew/Title",
  onChange
  
}) {
let selectedDataNewTaskTitleValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'data.new_task.title',
})
let selectedDataNewTaskTitleChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'data.new_task.title',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 data="selected.data.new_task.title"
 value={selectedDataNewTaskTitleValueData}
 onChange={selectedDataNewTaskTitleChangeData}
 required={true}
 marginTop={0}
 marginBottom={0}
 width="100%"
 label="Title"
 placeholder="Schedule online appointment"
/>
{children}
</React.Fragment>)
}